import { render, staticRenderFns } from "./TrustsChangedYN.vue?vue&type=template&id=72273ec9"
import script from "./TrustsChangedYN.vue?vue&type=script&lang=js"
export * from "./TrustsChangedYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports